class WorkInstructionDTO {
  _id;
  title;
  description;
  steps;
  packageId;

  constructor(data) {
    this._id = data._id || data.id;
    this.title = data.title;
    this.description = data.description;
    this.steps = data.steps || [];
    this.packageId = data.packageId;
  }
}

module.exports = WorkInstructionDTO;
